import { Icon } from "@iconify/react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DatePicker = ({
  variant = "default",
  label,
  labelIcon,
  placeholder,
  className,
  value,
  onChange,
}) => {
  const getVariantClassName = () => {
    let baseClassName =
      "relative w-full p-2 rounded-lg overflow-hidden outline-none text-sm ";
    switch (variant) {
      case "default":
        baseClassName +=
          "border border-[#1B51EC33] text-dark-blue placeholder:text-dark-blue ";
        break;
      case "primary-blur":
        baseClassName +=
          "bg-[#F1F5FF] text-dark-blue placeholder:text-dark-blue ";
        break;
    }

    baseClassName += className ? ` ${className} ` : "";
    return baseClassName;
  };

  const getLabelIconColorClassName = () => {
    let baseClassName = "";
    switch (variant) {
      case "default":
        baseClassName += "text-[#25347799] ";
        break;
      case "primary-blur":
        baseClassName += "text-primary ";
        break;
    }
    return baseClassName;
  };

  return (
    <div className="flex flex-col gap-2">
      {label && (
        <div className="flex flex-row items-center gap-2">
          {labelIcon && (
            <Icon
              icon={labelIcon}
              className={`w-4 h-4 ${getLabelIconColorClassName()}`}
            />
          )}
          <label className="text-sm font-medium">{label}</label>
        </div>
      )}
      <ReactDatePicker
        placeholderText={placeholder}
        selected={value}
        onChange={onChange}
        dateFormat="yyyy-MM-dd"
        className={getVariantClassName()}
      />
    </div>
  );
};

export default DatePicker;
